import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import Card from "components/Shared/Card/Card.js";
import CardHeader from "components/Shared/Card/CardHeader/CardHeader.js";
import CardBody from "components/Shared/Card/CardBody/CardBody.js";
import Table from "components/Recycler/Collectables/ArchivedBatches";

import { useDispatch, useSelector } from "react-redux";
import {
  getArchivedWaitingRecycler,
  approveBatch,
  rejectBatch,
} from "store/actions/recycler";

const WaitingBatchesRecycler = () => {
  const dispatch = useDispatch();
  const { archivedWaiting } = useSelector((state) => state.recycler);
  const [page, setPage] = useState(
    archivedWaiting ? archivedWaiting.pag.page : 1
  );
  const [amount, setAmount] = useState(
    archivedWaiting ? archivedWaiting.pag.amount : 10
  );
  const [orderField, setOrderField] = useState(
    archivedWaiting ? archivedWaiting.pag.order_field : "created_at"
  );
  const [orderType, setOrderType] = useState(
    archivedWaiting ? archivedWaiting.pag.order_type : "desc"
  );
  const [searchValue, setSearchValue] = useState("");
  const [searchBy, setSearchBy] = useState(
    archivedWaiting ? archivedWaiting.pag.search_by : "branch_name"
  );

  const history = useHistory();

  useEffect(() => {
    dispatch(
      getArchivedWaitingRecycler(
        {
          page,
          amount,
          order_field: orderField,
          order_type: orderType,
          search_value: searchValue,
          search_by: searchBy,
        },
        history
      )
    );
  }, [page, amount, orderField, orderType, searchValue, dispatch]);

  const showBatchHandler = (id) => {
    history.push("/admin/recycler/batch-items/" + id);
  };
  const approveBatchHandler = (id, price) => {
    dispatch(
      approveBatch(
        { id, minPrice: price.minPrice, maxPrice: price.maxPrice },
        {
          page,
          amount,
          order_field: orderField,
          order_type: orderType,
          search_value: searchValue,
          search_by: searchBy,
        },
        history,
        1
      )
    );
  };
  const rejectBatchHandler = (id) => {
    dispatch(
      rejectBatch(
        id,
        {
          page,
          amount,
          order_field: orderField,
          order_type: orderType,
          search_value: searchValue,
          search_by: searchBy,
        },
        history,
        1
      )
    );
  };

  return (
    <div>
      <Card>
        <CardHeader color="primary">
          <h4>Waiting Archived Batches</h4>
        </CardHeader>
        <CardBody>
          {archivedWaiting && (
            <div>
              <Table
                rows={archivedWaiting.data}
                totalRows={archivedWaiting.pag.total}
                rowsPerPage={amount}
                setRowsPerPage={setAmount}
                order={orderType}
                setOrder={setOrderType}
                orderBy={orderField}
                setOrderBy={setOrderField}
                page={page - 1}
                setPage={setPage}
                searchHandler={setSearchValue}
                searchValue={searchValue}
                selectedSearchBy={searchBy}
                handleSearchByChange={setSearchBy}
                showBatch={showBatchHandler}
                approveBatch={approveBatchHandler}
                rejectBatch={rejectBatchHandler}
              />
            </div>
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default WaitingBatchesRecycler;
